import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {TileIcon} from '@src/shared/models/tile-icon';
import {SpinnerComponent} from '../spinner/spinner.component';
import {NgClass} from '@angular/common';

@Component({
  selector: 'motn-icon-picker',
  templateUrl: './icon-picker.component.html',
  styleUrls: ['./icon-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SpinnerComponent,
    NgClass,
  ],
})
export class IconPickerComponent implements OnInit, AfterViewInit {
  @Input() icon: TileIcon;
  @Output() ready$: EventEmitter<null> = new EventEmitter<null>();
  @Output() iconPicked$: EventEmitter<TileIcon> = new EventEmitter<TileIcon>();

  ready: boolean = false;

  options: TileIcon[] = [
    'dot-circle', 'fan', 'fire', 'heat', 'snowflake', 'humidity', 'droplet-degree', 'raindrops',
    'hand-holding-water', 'water', 'water-rise', 'water-arrow-down', 'industry', 'gas-pump', 'leaf', 'seedling',
    'temperature-high', 'thermometer-half', 'thermometer-three-quarters', 'vial', 'flask', 'eye-dropper-half',
    'radiation-alt', 'biohazard', 'atom', 'magnet', 'lights-holiday', 'light-ceiling',
    'light-switch', 'lightbulb', 'phone', 'check-circle', 'clone', 'container-storage', 'eye', 'acorn',
    'archive', 'book-open', 'drone', 'ethernet', 'shield-alt', 'wallet', 'tasks-alt', 'signal-stream', 'server',
    'mailbox', 'outlet', 'battery-full', 'wave-sine', 'waveform', 'bolt', 'plug', 'users',
    'sensor', 'sensor-alert', 'sensor-fire', 'sensor-smoke', 'meter-fire', 'meter-droplet', 'meter-bolt', 'sink', 'faucet', 'faucet-drip',
    'sprinkler', 'pump', 'arrow-up-from-water-pump', 'sort-circle', 'tv', 'webcam', 'door-closed', 'door-open', 'window-frame', 'cogs', 'cog',
    'power-off', 'sun', 'wind', 'wind-warning', 'wind-turbine', 'certificate', 'network-wired',
    'globe', 'archway', 'building', 'car-building', 'chimney', 'church', 'city',
    'dungeon', 'garage-car', 'elevator', 'escalator', 'house', 'hospital', 'hotel', 'house-damage',
    'house-flood', 'house-flood-water-circle-arrow-right', 'landmark', 'kaaba', 'landmark-alt', 'monument', 'mosque',
    'place-of-worship', 'school', 'synagogue', 'torii-gate', 'university',
    'warehouse-alt', 'heart', 'ambulance', 'medkit', 'air-conditioner', 'bath',
    'bell', 'bell-on', 'fingerprint', 'flag', 'flag-usa', 'signal', 'sliders-h',
    'star', 'tools', 'trash', 'wifi', 'hard-hat', 'bomb', 'balance-scale', 'bug',
    'bus', 'dice', 'feather-alt', 'gamepad', 'guitar', 'music', 'life-ring',
    'lock-alt', 'print', 'rocket', 'toilet', 'tree', 'tree-alt', 'tree-large',
    'biking', 'dumbbell', 'clipboard-check', 'tachometer-fastest',
    'exclamation-triangle', 'clock', 'stopwatch', 'beer', 'jug', 'cocktail', 'wine-glass',
    'folder', 'smog',
  ];


  constructor() {
  }


  ngOnInit(): void {
    if (!this.icon) {
      this.icon = 'dot-circle';
    }
  }


  ngAfterViewInit() {
    // Nasty Safari hack
    setTimeout(() => {
      setTimeout(() => {
        this.ready = true;
      }, 0);
    }, 0);
  }


  pick(icon: TileIcon) {
    this.icon = icon;
    this.iconPicked$.emit(icon);
  }
}
